export default "__VITE_ASSET__2FZjuoF5__"